<template lang="pug">
.crud
  .container-fluid
    vm-row.heading(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
        div
          h2 {{ $t('invoices.detail') }}
    vm-row.heading.df(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=2 vm-sm=2)
        div
          span {{ $t('invoices.number') }}: {{ invoice.number }}
      vm-col(vm-type="flex" vm-align="center" vm-lg=2 vm-sm=2)
        div
          span {{ $t('invoices.purchase_order_display') }}: {{ invoice.purchase_order_display }}
      vm-col(vm-type="flex" vm-align="center" vm-lg=4 vm-sm=4)
        div
          span {{ $t('invoices.customer_display') }}: {{ invoice.purchase_order.customer_display }}
    .df
      Card(:title="$t('invoices.total')" :background="false" width="25%" :itemLeft="false" :amount="invoice.total" :isText="false" :cash="true" :horizontal="false")
      Card(:title="$t('invoices.subtotal')" :background="false" width="25%" :itemLeft="false" :amount="invoice.subtotal" :isText="false" :cash="true" :horizontal="false")
      Card(:title="$t('invoices.tax_amount')" :background="false" width="25%" :itemLeft="false" :text="invoice.tax_type" :isText="true" :cash="false" :isPercent="true" :horizontal="false")
      Card(:title="$t('invoices.currency')" :background="false" width="25%" :itemLeft="false" :text="invoice.purchase_order.currency.code" :isText="true" :cash="false" :isPercent="false" :horizontal="false")
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(v-model="selected"  max-height="350px" :data="invoicedProducts" )
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
              .d-flex.justify-content-between
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                      vm-date-picker.filter(type="daterange" :label="$t('customer_purchase_order_details.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                      //- Add filters
                          Agrega los filtros que prefieras por ejemplo:
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                          NOTA: (agregar clase .filter)
                      .filter.d-flex
                        vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('customer_purchase_order_details.'+ item)")
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ $t('customer_purchase_order_details.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'status' && column != 'created_at' && column != 'delivery_status' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                vm-status-indicator(v-if="column == 'delivery_status'" :pulse="data[indextr]['delivery_status'] !== 'Activo'" :color="colorStatus(data[indextr]['delivery_status'])") {{ $t('customer_purchase_order_details.'+ data[indextr]['delivery_status']) }}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == 'Inactivo'" @click="setActionRecord(data[indextr], 'actived')")
                    vm-icon(icon="person-done-outline")
                    slot &nbsp;{{ $t('strings.action_active') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
    vm-row(vm-w="12")
      h2.payments_title {{ $t('customer_purchase_order_details.payments') }}
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(v-model="selected"  max-height="350px" :data="payments" )
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)" width="300px")
              .d-flex.justify-content-between
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                      vm-date-picker.filter(type="daterange" :label="$t('customer_purchase_order_details.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                      //- Add filters
                          Agrega los filtros que prefieras por ejemplo:
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                          NOTA: (agregar clase .filter)
                      .filter.d-flex
                        vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('customer_purchase_order_details.'+ item)")
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columnsPayment") {{ $t('payments.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columnsPayment")
                slot(v-if="column == 'total' || column == 'amount'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at' || column == 'date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column == 'type'") {{ $t('payments.'+ data[indextr]['type']) }}
                slot(v-if="column != 'type' && column != 'created_at' && column != 'name' && column != 'name' && column != 'date' && column != 'total' && column != 'amount'") {{data[indextr][column]}}
              vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.edit') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deletePaymentConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
                      //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Invoices')

export default {
  name: 'InvoiceDetail',
  components: {
    Card: () => import('@/components/aditionals/Card')
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    total: 1,
    columns: [
      'id',
      'name',
      'delivery_status',
      'production_area_display',
      'delivery_date',
      'destination',
      'quantity',
      'unit_price',
      'amount',
      'invoiced_amount',
      'created_at'
    ],
    columnsPayment: [
      'subtotal',
      'tax_amount',
      'total',
      'date',
      'type',
      'user_display',
      'created_at'
    ],
    searchParam: '',
    status: [
      {
        value: 'on_time',
        color: 'primary'
      },
      {
        value: 'mistime',
        color: 'warning'
      },
      {
        value: 'cancelled',
        color: 'danger'
      },
      {
        value: 'delivered',
        color: 'success'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        number: '',
        project: {
          name: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['catalog', 'pagination', 'filterParams', 'invoice', 'invoicedProducts', 'payments'])
  },
  async created () {
    await this.loadRecord({ id: this.$route.params.id })
    await this.loadInvoicedProducts({ id: this.$route.params.id, page: 1 })
    this.loadPayments({ page: 1, id: this.$route.params.id })
  },
  methods: {
    ...mapActions([
      'setSubTotal',
      'setTotalAmount',
      'createInvoice',
      'loadRecord',
      'loadInvoicedProducts',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'loadPayments'
    ])
  }
}
</script>
<style lang="scss">

.payments_title{
  margin-bottom: 1rem;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
